// Race SOG = distance (nm) / race time (hours). Returns "" if either missing/invalid.
export function computeRaceSog(distance, time) {
  const dist = parseFloat(distance);
  if (!dist || !time) return "";
  const parts = String(time).split(":").map(Number);
  if (parts.some(isNaN)) return "";
  let hours = 0;
  if (parts.length === 3) hours = parts[0] + parts[1]/60 + parts[2]/3600;
  else if (parts.length === 2) hours = parts[0]/60 + parts[1]/3600;
  else return "";
  if (hours <= 0) return "";
  return (dist / hours).toFixed(1);
}
